import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const SecuredRoute = ({
  component: Component,
  token,
  validToken,
  syncLoadingStop,
  syncLoadingStart,
  ...otherProps
}) => (
  <Route
    {...otherProps}
    render={(props) => {
      if (!validToken && !token) {
        return <Redirect to="/" />;
      }
      return (
        <Component
          {...props}
          syncLoadingStop={syncLoadingStop}
          syncLoadingStart={syncLoadingStart}
        />
      );
    }}
  />
);

export default SecuredRoute;
